/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/experiment.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiExperimentStorageState } from './ApiExperimentStorageState';
import {
  ApiExperimentStorageStateFromJSON,
  ApiExperimentStorageStateFromJSONTyped,
  ApiExperimentStorageStateToJSON,
  ApiExperimentStorageStateToJSONTyped,
} from './ApiExperimentStorageState';
import type { ApiResourceReference } from './ApiResourceReference';
import {
  ApiResourceReferenceFromJSON,
  ApiResourceReferenceFromJSONTyped,
  ApiResourceReferenceToJSON,
  ApiResourceReferenceToJSONTyped,
} from './ApiResourceReference';

/**
 *
 * @export
 * @interface ApiExperiment
 */
export interface ApiExperiment {
  /**
   * Output. Unique experiment ID. Generated by API server.
   * @type {string}
   * @memberof ApiExperiment
   */
  id?: string;
  /**
   * Required input field. Unique experiment name provided by user.
   * @type {string}
   * @memberof ApiExperiment
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ApiExperiment
   */
  description?: string;
  /**
   * Output. The time that the experiment created.
   * @type {Date}
   * @memberof ApiExperiment
   */
  created_at?: Date;
  /**
   * Optional input field. Specify which resource this run belongs to.
   * For Experiment, the only valid resource reference is a single Namespace.
   * @type {Array<ApiResourceReference>}
   * @memberof ApiExperiment
   */
  resource_references?: Array<ApiResourceReference>;
  /**
   *
   * @type {ApiExperimentStorageState}
   * @memberof ApiExperiment
   */
  storage_state?: ApiExperimentStorageState;
}

/**
 * Check if a given object implements the ApiExperiment interface.
 */
export function instanceOfApiExperiment(value: object): value is ApiExperiment {
  return true;
}

export function ApiExperimentFromJSON(json: any): ApiExperiment {
  return ApiExperimentFromJSONTyped(json, false);
}

export function ApiExperimentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiExperiment {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    name: json['name'] == null ? undefined : json['name'],
    description: json['description'] == null ? undefined : json['description'],
    created_at: json['created_at'] == null ? undefined : new Date(json['created_at']),
    resource_references:
      json['resource_references'] == null
        ? undefined
        : (json['resource_references'] as Array<any>).map(ApiResourceReferenceFromJSON),
    storage_state:
      json['storage_state'] == null
        ? undefined
        : ApiExperimentStorageStateFromJSON(json['storage_state']),
  };
}

export function ApiExperimentToJSON(json: any): ApiExperiment {
  return ApiExperimentToJSONTyped(json, false);
}

export function ApiExperimentToJSONTyped(
  value?: ApiExperiment | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    name: value['name'],
    description: value['description'],
    created_at:
      value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
    resource_references:
      value['resource_references'] == null
        ? undefined
        : (value['resource_references'] as Array<any>).map(ApiResourceReferenceToJSON),
    storage_state: ApiExperimentStorageStateToJSON(value['storage_state']),
  };
}
